// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({205: "selectCompany",574: "version",615: "home",801: "notificationHatchConfigure",}[chunkId] || chunkId) + "." + {205: "6f2f6c81f4f6dd56",30: "36c1970c60c0316a",574: "34e0b527e3618d21",594: "d5a86f30c46c117e",615: "d9e52fe428207414",682: "41368ecd0db9048b",801: "7fe424731bcb8480",}[chunkId] + ".js"
}